import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { FindingsPage } from "@/features/findings";

const findingsSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  limit: z.coerce.number().int().min(1).max(100).catch(20),
  q: z.string().optional(),
  severity: z.string().optional(),
  status: z.string().optional(),
  source: z.string().optional(),
  owner: z.string().optional(),
});

export const Route = createFileRoute("/findings/")({
  validateSearch: findingsSearchSchema,
  component: () => (
    <PermissionGuard module="findings">
      <FindingsPage />
    </PermissionGuard>
  ),
});
